import React from 'react'
import './AvatarAndName.css'

const AvatarAndNameUI = ({avatarUrl, userName, userLeft}) =>
  <div className='g_flex_h g_ava_name'>
    {
      !userLeft &&
      <img src={avatarUrl} alt='' />
    }
    {
      userLeft &&
      <div className='icon icon-user' />
    }
    <div className='g_m_left_50 g_muted'>{userName}</div>
  </div>

export default AvatarAndNameUI
